import React from 'react';
import './Header.css'
import { Menu } from 'semantic-ui-react';

export default ()=>{

    return(
        <div>
        <Menu style={{marginTop:'40px'}}>
            <a className="item">PortFolio</a>
        

        <Menu.Menu position="right">
            <a href="https://covid-19-927c2.web.app" className="item">Covi-Helper</a>

            <a href="https://drive.google.com/file/d/16REqsSb3VHcYSy8r5bH_K1C0hi5B1mwu/view?usp=sharing" className="item">Resume</a>

        </Menu.Menu>



        </Menu>

        </div>
    );

}